'use client'

import { authClient } from '@/lib/auth-client'
import { useEffect } from 'react'

export function AutoSignIn() {
  useEffect(() => {
    void authClient.signIn.social({ provider: 'cognito', callbackURL: '/api/auth/post-login' })
  }, [])

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-muted-foreground text-sm">Redirecting to login...</div>
    </div>
  )
}
